import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  base: {
    height: '20px',
    width: '20px',
    color: 'fg.subtle',
  },
});

export default iconRecipe;
